import { TableBody, TableCell, TableRow } from "@mui/material";
import React from "react";

const keyPair = {
  "Shipment Number": "shipmentNumber",
  "Consignee Name": "consigneeName",
  "Consignor Name": "consignorName",
  "Origin Port Name": "originPortName",
  "Origin Port Code": "originPortCode",
  "Destination Port Name": "destinationPortName",
  "Destination Port Code": "destinationPortCode",
  "House Bill Number": "houseBillNumber",
  "Master Bill Number": "masterBillNumber",
  "Container Numbers": "containerNumbers",
  "Total Number Of Container": "totalNumberOfContainer",
  "Order Ref": "orderRef",
  "Total Volume": "totalVolume",
  "Volume Unit": "volumeUnit",
  "Total Weight": "totalWeight",
  "Weight Unit": "weightUnit",
  "Container Mode": "containerMode",
  "Vessel Name": "vesselName",
  "Empty Release Shipper": "emptyreleaseshipper",
  "Wharfage Gate In": "wharfagegatein",
  "Container Loaded": "containerloaded",
  "IS FFiled": "milestoneISFfiled",
  "Arrival Notice Sent": "arrivalNoticeSent",
  "Freight Released": "containerFreightreleased",
  "Customs Released": "containerCustomsreleased",
  "Delivery Order Sent": "milestoneDeliveryordersent",
  "Picked Up": "pickedup",
  "Empty Container Returned": "emptycontainerreturned",
  Cost: "cost",
  "Container Numbers And Type": "containerNumbersAndTypes",
  "Transport Leg Departure Second": "transportLegDeparture_Second",
  "Container Unloaded at Transhipment Port":
    "containerUnloadedattranshipmentport",
  "Arrived at Destination": "arrivedatDestination",
  "Shipping Advice Sent": "shippingAdviceSent",
  "Departure from Loading Port": "departurefromLoadingPort",
  "Container Freight Released": "containerFreightreleased",
  "Container Customs Released": "containerCustomsreleased",
  "Arrival at Final Discharge Port": "arrivalatFinalDischargePort",
  "Container Empty Returned": "containerEmptyReturned",
  "Departure from First Load Port": "departurefromFirstLoadPort",
  "Departure from Transhipment Port": "departurefromTranshipmentPort",
  "Container Picked Up": "containerPickedUp",
  "Empty Containers Returned": "emptycontainersreturned",
  "Transport Leg Arrival Second": "transportLegArrival_Second",
  "Shipment Available for Pickup": "shipmentavailableforpickup",
  "Consol Created": "consolCreated",
  "Transport Leg Departure": "transportLegDeparture",
  "PreAlert Received": "preAlertReceived",
  "Destination Arrival": "destinationArrival",
  "Shipment Created": "shipmentCreated",
  "Container Loaded at Transhipment Port": "containerLoadedattranshipmentport",
  "Shipment Picked Up": "shipmentpickedup",
  "All Empty Containers Returned": "allEmptyContainersReturned",
  "Delivery Cartage Complete Finalised": "deliveryCartageCompleteFinalised",
  "Transport Leg Arrival First": "transportLegArrival_First",
  "Arrival at Transhipment Port": "arrivalatTranshipmentPort",
  "Container Unloaded": "containerUnloaded",
  "All Import Documents Received": "allImportDocumentsReceived",
  "Cargo Available": "cargoAvailable",
  "Container Delivered": "containerDelivered",
  "Container Available for Pick Up": "containerAvailableforPickUp",
  "All Containers Released from Wharf": "allContainersreleasedfromWharf",
  ATD: "atd",
  ATA: "ata",
  ETD: "etd",
  ETA: "eta",
  "Origin UNLOCO":"originUNLOCO",
  "Origin Country":"originCountry",
  "Destination UNLOCO":"destinationUNLOCO",
  "Destination Country":"destinationCountry",
  "Origin Port Name":"originPortName",
  "Destination Port Name":"destinationPortName",
  "Shipment ETD":"shipmentOriginETD",
  "Shipment ETA":"shipmentDestinationETA",
  "Carrier Name":"carrierName",
  "Carrier Code":"carrierCode",
  "CO2 Emission Value (Kg)":"totalAmount",
  "Shipmemt Number":"shipmemtNumber",
  "Shipper Name":"shipperName",
};
const ShipmentReportTableBodySingleRow = ({ data, key, coloumn }) => {
  console.log("keyvalue",data,key,coloumn);
  
  return (
    <TableRow key={key}>
      {coloumn?.map((info, index) => {
        if (info?.value) {
          return (
            console.log("info?.value",data),
       
             <TableCell>{data[keyPair[info?.displayColumnName]]}</TableCell>
          );
        }
      })}
    </TableRow>
  );
};
const ShipmentReportTableBody = ({ coloumn, reportInformation }) => {
  console.log(
    "reportInformation",
   reportInformation)

  return (
    <TableBody>
      {reportInformation?.map((data, index) => {
        return (
          <ShipmentReportTableBodySingleRow
            data={data}
            key={index}
            coloumn={coloumn}
          />
        );
      })}
    </TableBody>
  );
};

export default ShipmentReportTableBody;
